import { h } from "preact";
import style from "./style.css";

const Loading = () => {
    return <div className={style.container}>
        <div className={style["lds-roller"]}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
};

export default Loading;
